<template>
    <div class="widget-header">
        <h3 class="widget-header__title">
            {{ props.title }}
        </h3>

        <div class="widget-header__control" v-if="$slots.control">
            <slot name="control"></slot>
        </div>
    </div>
</template>
<script setup lang="ts">
// Other
import { defineProps } from 'vue';

const props = defineProps({
    title: { type: String, default: '' },
});
</script>
<style lang="scss">
.widget-header {
    display: flex;
    height: 2.5rem;
    justify-content: space-between;

    &__title {
        margin: 0;

        @include h3();
        @include overflow-ellipsis();

        line-height: 2.5rem;
    }

    &__control {
        display: flex;
        gap: 0.375rem;
        align-items: center;
    }
}
</style>
